export const brandName = '黑曝现场';

export const navLinks = [
  { id: 'hot', label: '热门爆料' },
  { id: 'live', label: '实时速递' },
  { id: 'topics', label: '主题分类' },
  { id: 'latest', label: '最新更新' },
  { id: 'insight', label: '深度观察' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于我们' },
];

export const heroStats = [
  { value: '128', suffix: '条', label: '今日更新爆料' },
  { value: '3.6', suffix: '万', label: '围观吃瓜群众' },
  { value: '12', suffix: '个', label: '持续追踪事件' },
  { value: '每', suffix: '小时', label: '速递即时刷新' },
];

export const hotExposes = [
  {
    id: 'hot-1',
    tag: '独家首发',
    title: '直播带货「低价承诺」翻车始末：一场三小时的复盘',
    summary:
      '从口播话术到后台改价,我们按时间线还原了整场争议的起因、发酵与官方回应,顺带聊聊类似套路怎么识别。',
    author: '值班吃瓜员',
    time: '2 小时前',
    heat: '9.8 万',
    image:
      'https://readdy.ai/api/search-image?query=a%20dark%20moody%20abstract%20broadcast%20studio%20scene%20with%20warm%20amber%20rim%20light%2C%20silhouette%20of%20a%20microphone%20and%20spotlight%2C%20film%20grain%20texture%2C%20editorial%20magazine%20photography%20style%2C%20deep%20burgundy%20and%20gold%20tone%2C%20clean%20composition&width=800&height=600&seq=expose-live-01&orientation=landscape',
  },
  {
    id: 'hot-2',
    tag: '速递',
    title: '某测评账号删稿风波：一条视频下架背后的三种说法',
    summary:
      '品牌方、账号团队、平台规则三方各执一词,我们把公开信息摆在一起,标出仍未证实的疑点,不做站队只做梳理。',
    author: '线索组',
    time: '5 小时前',
    heat: '7.2 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20smartphone%20screen%20glow%20in%20a%20dark%20room%20with%20warm%20vermilion%20light%20spill%2C%20minimal%20editorial%20still%20life%2C%20soft%20shadows%2C%20cinematic%20contrast%2C%20moody%20premium%20magazine%20aesthetic%2C%20clean%20uncluttered%20background&width=800&height=600&seq=expose-live-02&orientation=landscape',
  },
  {
    id: 'hot-3',
    tag: '背景梳理',
    title: '「人设崩塌」到底发生了什么?先把时间线摆出来',
    summary:
      '一条评论区截图引爆全网,但最早的出处是谁?我们顺着转发链往回找,发现事件起点和想象中不太一样。',
    author: '背景组',
    time: '8 小时前',
    heat: '6.4 万',
    image:
      'https://readdy.ai/api/search-image?query=dark%20artistic%20studio%20table%20with%20scattered%20photographs%20and%20a%20warm%20desk%20lamp%2C%20mysterious%20investigative%20mood%2C%20amber%20and%20deep%20brown%20tones%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20clean%20composition&width=800&height=600&seq=expose-live-03&orientation=landscape',
  },
  {
    id: 'hot-4',
    tag: '即时消息',
    title: '第一弹之后:围观人群最关心的五个问题',
    summary:
      '当事人会不会回应?证据链是否完整?平台会不会介入?我们整理了评论区出现频率最高的疑问,逐条给出目前能确认的答案。',
    author: '现场组',
    time: '11 小时前',
    heat: '5.1 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20glowing%20video%20play%20button%20symbol%20floating%20above%20dark%20reflective%20surface%2C%20warm%20vermilion%20and%20gold%20lighting%2C%20premium%20cinematic%20editorial%20style%2C%20soft%20bokeh%2C%20minimal%20clean%20background&width=800&height=600&seq=expose-live-04&orientation=landscape',
  },
];

export const tickerItems = [
  '【速递】低成本「赠品变收费」争议,平台客服已介入核查',
  '【首发】某测评账号发布澄清视频,时长 18 分钟',
  '【更新】「直播间报价」事件新增第三方数据截图 3 张,来源待核实',
  '【即时】相关话题登上热榜第 7 位,讨论量突破 20 万',
  '【速递】当事人账号暂时关闭评论区,今晚预计复播',
  '【首发】品牌方发布说明,承认话术培训存在不规范',
];

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-2-line', count: 128 },
  { id: 'dynamics', name: '网红动态', icon: 'ri-user-voice-line', count: 34 },
  { id: 'livestream', name: '直播圈', icon: 'ri-live-line', count: 27 },
  { id: 'commerce', name: '带货争议', icon: 'ri-shopping-bag-3-line', count: 23 },
  { id: 'emotion', name: '情感观察', icon: 'ri-heart-3-line', count: 18 },
  { id: 'platform', name: '平台规则', icon: 'ri-shield-check-line', count: 15 },
  { id: 'backstage', name: '幕后解析', icon: 'ri-movie-2-line', count: 11 },
];

export const latestFeed = [
  {
    id: 'feed-1',
    title: '「赠品变收费」争议再起:三位消费者晒出同一订单截图',
    summary: '同一场直播、同一款赠品,却出现了三种结算价格。我们把订单截图按时间排了序。',
    category: 'commerce',
    categoryName: '带货争议',
    author: '值班吃瓜员',
    time: '1 小时前',
    readTime: '4 分钟',
    heat: 92000,
  },
  {
    id: 'feed-2',
    title: '直播中途突然中断,主播团队回应称「设备调试」',
    summary: '中断时长 27 分钟,期间粉丝群里流传了多个版本的说法,官方暂未进一步说明。',
    category: 'livestream',
    categoryName: '直播圈',
    author: '现场组',
    time: '3 小时前',
    readTime: '3 分钟',
    heat: 71000,
  },
  {
    id: 'feed-3',
    title: '测评账号集体改口?我们对比了他们一周内的措辞变化',
    summary: '从「强烈推荐」到「理性看待」,同一批账号的文案变化被网友做了词频统计。',
    category: 'dynamics',
    categoryName: '网红动态',
    author: '数据组',
    time: '6 小时前',
    readTime: '6 分钟',
    heat: 65000,
  },
  {
    id: 'feed-4',
    title: '分手声明冲上热搜,双方粉丝却在同一件事上达成共识',
    summary: '感情纠纷类事件往往最难辨真伪,我们只整理双方公开表态,不做道德评判。',
    category: 'emotion',
    categoryName: '情感观察',
    author: '观察员小满',
    time: '9 小时前',
    readTime: '5 分钟',
    heat: 58000,
  },
  {
    id: 'feed-5',
    title: '平台上线「争议内容提示」功能,哪些账号会受影响?',
    summary: '新规则要求争议类话题标注信息来源,这可能会改变不少爆料账号的发布习惯。',
    category: 'platform',
    categoryName: '平台规则',
    author: '规则组',
    time: '12 小时前',
    readTime: '6 分钟',
    heat: 43000,
  },
  {
    id: 'feed-6',
    title: '一条视频引爆全网,但最先发布的人已经删掉了账号',
    summary: '溯源发现,最早的那条内容来自一个只有几百粉的小号,现已注销。',
    category: 'backstage',
    categoryName: '幕后解析',
    author: '背景组',
    time: '15 小时前',
    readTime: '7 分钟',
    heat: 39000,
  },
  {
    id: 'feed-7',
    title: '「同款不同价」被扒出后,品牌方连夜修改了详情页',
    summary: '从商品页的历史快照看,主图文案在凌晨两点被替换过一次,变化点在这三处。',
    category: 'commerce',
    categoryName: '带货争议',
    author: '值班吃瓜员',
    time: '18 小时前',
    readTime: '4 分钟',
    heat: 36000,
  },
  {
    id: 'feed-8',
    title: '复播首秀数据出炉:在线人数是争议前的几分之一?',
    summary: '我们抓取了公开的场观曲线,和事件前的三场直播做了对比,差距一目了然。',
    category: 'livestream',
    categoryName: '直播圈',
    author: '数据组',
    time: '21 小时前',
    readTime: '5 分钟',
    heat: 31000,
  },
  {
    id: 'feed-9',
    title: '新人主播抱团维权,聊天记录还原了一场「分成谈判」',
    summary: '从分成比例到解约条款,这份聊天记录让不少同行直呼「太熟悉了」。',
    category: 'dynamics',
    categoryName: '网红动态',
    author: '观察员小满',
    time: '1 天前',
    readTime: '6 分钟',
    heat: 28000,
  },
  {
    id: 'feed-10',
    title: '争议账号的评论区,正在变成大型「考古」现场',
    summary: '网友翻出了三年前的一条旧动态,和如今的说法形成了微妙对照。',
    category: 'backstage',
    categoryName: '幕后解析',
    author: '背景组',
    time: '1 天前',
    readTime: '4 分钟',
    heat: 24000,
  },
  {
    id: 'feed-11',
    title: '「人设」与「真人」的落差,为什么总能引爆讨论?',
    summary: '或许比起事件本身,大家更在意的是被精心包装过的那份信任。',
    category: 'emotion',
    categoryName: '情感观察',
    author: '专栏作者阿澈',
    time: '2 天前',
    readTime: '8 分钟',
    heat: 21000,
  },
  {
    id: 'feed-12',
    title: '搬运、剪辑、加字:爆料视频是怎么被二次加工的?',
    summary: '同一段素材流出后,不同账号的剪辑方式差别巨大,有的甚至改变了原意。',
    category: 'platform',
    categoryName: '平台规则',
    author: '规则组',
    time: '2 天前',
    readTime: '5 分钟',
    heat: 18000,
  },
];

export const insightArticle = {
  tag: '深度观察',
  title: '吃瓜也有方法论:面对一条爆料,先问这五个问题',
  lead:
    '热点来得快,去得也快。与其被情绪推着走,不如掌握一套简单的核对思路——它不能让你永远正确,但至少能让你离事实更近一步。',
  outline: ['信源是谁', '证据是否完整', '时间线有没有矛盾', '有没有利益相关方', '平台是否已介入'],
  paragraphs: [
    {
      heading: '一、信源是谁',
      body:
        '看到一条爆料,先找它最早的出处。是当事人本人、其身边人员,还是一个匿名小号?不同信源的可靠性差距很大。截图可以伪造,聊天记录可以拼接,唯一相对难以作假的是完整的、带上下文的原始素材。',
    },
    {
      heading: '二、证据是否完整',
      body:
        '一条被裁掉时间、地点和来龙去脉的截图,信息量往往接近于零。判断证据是否完整,可以看它有没有上下文、有没有原始载体、有没有可以交叉验证的第三方信息。孤证不立,这一点在网络爆料里同样适用。',
    },
    {
      heading: '三、时间线有没有矛盾',
      body:
        '把事件的关键节点按时间排一遍,很多问题会自动浮出来:某段聊天记录的时间早于认识时间、某段直播的时间与行程冲突、某条动态在事件发生前就已经存在。时间线是最容易被忽视,也最容易暴露破绽的地方。',
    },
    {
      heading: '四、有没有利益相关方',
      body:
        '爆料者可能是受害者,也可能是竞争者。这不代表他说的一定是假的,但足够提醒我们多想一层:这条内容被放出来的时机、渠道和受益方是谁?带着这个问题再看一遍,你会发现很多细节的位置变得合理了。',
    },
    {
      heading: '五、平台是否已介入',
      body:
        '当内容涉及明确违规,平台通常会给出处理结果:限流、下架、标注争议、封禁账号。平台的处理动作是一个参考坐标,但它也不等于最终结论。真正稳妥的做法,是把平台动作当作线索之一,而不是全部。',
    },
  ],
  image:
    'https://readdy.ai/api/search-image?query=editorial%20desk%20scene%20with%20a%20notebook%2C%20timeline%20sketches%20and%20a%20warm%20lamp%2C%20thoughtful%20investigative%20atmosphere%2C%20amber%20and%20muted%20brown%20palette%2C%20cinematic%20soft%20light%2C%20premium%20magazine%20photography&width=900&height=600&seq=insight-deep-01&orientation=landscape',
};

export const faqs = [
  {
    q: '「网红黑曝第一弹」是什么意思?',
    a: '「第一弹」是我们对同一个热点事件首批整理内容的叫法。当事件有新的进展时,我们会以「第二弹」「第三弹」的方式持续更新,方便你顺着编号一路看完整个事件的来龙去脉。',
  },
  {
    q: '这些爆料内容是从哪里来的?',
    a: '内容来自公开的社交平台、直播间、评论区与网友投稿线索。我们不接受来源不明、无法核对的独家素材,涉及人身攻击、隐私信息的内容一律不发布。',
  },
  {
    q: '网站上的内容都经过证实了吗?',
    a: '我们会在每条内容里标注目前能确认的部分和仍在核实中的疑点。即便如此,事件仍在发展,结论可能随新信息变化,建议把它当作线索而不是定论。',
  },
  {
    q: '多久更新一次?',
    a: '「实时速递」板块全天滚动更新,通常在事件发酵的关键节点几十分钟内就会有新消息;「深度观察」的梳理文章一般在事件稳定后 12 小时内发布。',
  },
  {
    q: '我可以投稿或提供线索吗?',
    a: '可以。页面底部的订阅表单可以留下你的联系方式,备注「线索」即可。对于有价值的线索,编辑组会主动与你联系核实,请务必保护好自己和他人的隐私。',
  },
  {
    q: '为什么有些内容会被下架或修改?',
    a: '常见原因有三种:当事人提供了新的证据、原始素材被证明不完整、或内容涉及平台不允许的隐私信息。修改记录会保留在内容更新日志里,不做静默删除。',
  },
];

export const testimonials = [
  {
    name: '柚子不加班',
    role: '三年老瓜农',
    content:
      '最舒服的一点是不带节奏。别的地方上来就定性,这里会把「已确认」和「待核实」分开写,看完心里有底。',
  },
  {
    name: '阿哲的日常',
    role: '直播运营',
    content:
      '做这行的,热点基本靠这儿追。速递更新快,时间线整理得比很多大号都清楚,省了我不少翻评论区的时间。',
  },
  {
    name: '麦麦爱看戏',
    role: '普通围观群众',
    content:
      '之前吃过太多反转的亏,现在习惯先来这看梳理再看别的。至少它不会替我做判断,这点很难得。',
  },
];

export const brandPoints = [
  {
    icon: 'ri-search-eye-line',
    title: '多源核对',
    desc: '每条内容至少交叉两个公开信源,来源不明的一律标注「待核实」。',
  },
  {
    icon: 'ri-time-line',
    title: '时间线优先',
    desc: '用时间线还原事件顺序,而不是用情绪推动叙事,反转也如实记录。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '不下场站队',
    desc: '梳理事实、保留疑点,把判断权交还给读者,不做道德审判。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续跟进',
    desc: '事件有新进展就补更,编号连续,错过一弹也能顺着补齐。',
  },
];

export const brandImage =
  'https://readdy.ai/api/search-image?query=abstract%20crowd%20of%20soft%20blurred%20silhouettes%20under%20warm%20amber%20stage%20lights%2C%20cinematic%20editorial%20photography%2C%20deep%20burgundy%20background%2C%20atmospheric%20haze%2C%20premium%20magazine%20cover%20aesthetic%2C%20high%20detail&width=800&height=800&seq=brand-scene-01&orientation=squarish';